import { NextPage } from 'next';
import Head from 'next/head';
import styled from '@emotion/styled';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

// components
import DefaultLayout from '@components/_templates/DefaultLayout';
import ResetContent from '@components/_templates/auth/ResetContent';

// constants
import { MOBILE_MODE } from '@constants/size';
import Title from '@components/_atoms/Title';
import { useTranslation } from 'next-i18next';

const ResetWrapper = styled.div`
  width: 100%;
  max-width: 344px;
  padding: 110px 0;
  margin: 0 auto;

  @media ${MOBILE_MODE} {
    max-width: 320px;
    padding: 104px 0;
  }
`;

const TitleWrapper = styled.div`
  margin-bottom: 80px;

  @media ${MOBILE_MODE} {
    margin-bottom: 56px;
  }
`;

const Reset: NextPage = () => {
  const { t } = useTranslation('auth');

  return (
    <>
      <Head>
        <title>{t('find.reset.meta-title')}</title>
        <meta name="title" content={t('find.reset.meta-title')} />
      </Head>
      <DefaultLayout>
        <ResetWrapper>
          <TitleWrapper>
            <Title content={t('find.reset.title')} />
          </TitleWrapper>

          {/* Reset Content */}
          <ResetContent />
          {/* Reset Content end */}
        </ResetWrapper>
      </DefaultLayout>
    </>
  );
};

export const getStaticProps = async ({ locale }: { locale: any }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['auth', 'common', 'component'])),
  },
});

export default Reset;
